import PayPayback from '../PayPayback';

const PayPaybackContainer = () => {
  return <PayPayback />;
};

export default PayPaybackContainer;
